import { NodeId } from '@craftjs/core';
import { createContext } from 'use-context-selector';

export type LayoutAttachmentType = {
  file: File;
  fileName: string;
  // Is used for matching file with layout while fileId is null
  nodeId: string | null;
  fileId: string | null;
};

export type AttachmentsContextType = {
  attachments: Record<NodeId, LayoutAttachmentType>;
  addAttachment: (nodeId: NodeId, attachment: LayoutAttachmentType) => void;
  removeAttachment: (nodeId: NodeId) => void;
  uploadFiles?: () => Promise<void>;
  downloadFiles?: () => Promise<void>;
};

const defaultValues: AttachmentsContextType = {
  attachments: {},
  addAttachment: () => {},
  removeAttachment: () => {},
};

export const AttachmentsContext = createContext(defaultValues);
